import { StateUtils } from '@spartacus/core';

export const FIND_STORES = '[StoreFinder] Find Stores';
export const FIND_STORES_FAIL = '[StoreFinder] Find Stores Fail';
export const FIND_STORES_SUCCESS = '[StoreFinder] Find Stores Success';
export const STORE_FINDER_DATA = '[StoreFinder] Store Finder Data';


export class CustomFindStores extends StateUtils.LoaderLoadAction {
  readonly type = FIND_STORES;
  constructor(public payload: any) {
    super(STORE_FINDER_DATA);
  }
}

export class CustomFindStoresFail extends StateUtils.LoaderFailAction {
  readonly type = FIND_STORES_FAIL;
  constructor(public payload: any) {
    super(STORE_FINDER_DATA, payload);
  }
}

export class CustomFindStoresSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = FIND_STORES_SUCCESS;
  constructor(public payload: any) {
    super(STORE_FINDER_DATA);
  }
}

export type CustomFindStoresAction =
  | CustomFindStores
  | CustomFindStoresFail
  | CustomFindStoresSuccess
